<div class="w-100 center mb3" *ngIf="useIncomingFlightsFeature">
  <div aria-live="polite" class="clip">{{ ariaLiveMessage }}</div>

  <div class="inbound-plane-button-neg-ml">
    <jb-action
      [ariaExpanded]="isExpanded"
      (click)="getIncomingFlightDetails(flightTrackerLeg)"
      buttonType="button"
    >
      <div class="flex items-center">
        {{
          isExpanded
            ? inboundFlightCopy?.hideButtonText
            : inboundFlightCopy?.showButtonText
        }}

        <jb-expandable-indicator
          class="ml1"
          [iconSize]="indicatorSize"
          [value]="isExpanded"
        />
      </div>
    </jb-action>
  </div>

  <jb-expandable-section
    [id]="flightTrackerLeg?.tailNumber"
    [isExpanded]="isExpanded"
  >
    <!-- DESKTOP -->
    <div
      *ngIf="!useDialogDisplay"
      class="w-100 s-body flex items-center justify-center"
    >
      <span
        *ngIf="!isLoading && errorMessage"
        class="bg-medium-grey shine-lines"
      >
        {{ errorMessage }}
      </span>

      <dot-text-block
        *ngIf="isLoading && !flightStatus"
        [height]="28"
        [width]="60"
        bgColor="medium-grey"
      />

      <div
        *ngIf="!isLoading && flightStatus"
        class="w-100 flex items-center justify-center"
      >
        <jb-flight-tracker-results-status-column
          [flightTrackerLeg]="{ flightStatus: flightStatus?.flightStatus }"
          [useStatusColumnCSS]="false"
        />

        <div>
          <span class="clip">{{ inboundFlightCopy?.originAirport }}: </span>
          <span>
            {{ flightStatus?.originAirport }}
          </span>
        </div>

        <div class="relative ml2 mr4 inbound-plane-animation">
          <jb-flight-tracker-results-animation
            [blueLinePercentage]="90"
            [flightLegData]="flightStatus"
            [useCoreBlue]="true"
            [useFullWidth]="true"
          />
        </div>

        <div>
          <span class="clip"
            >{{ inboundFlightCopy?.destinationAirport }}:
          </span>
          <span class="ml2"> {{ flightStatus?.destinationAirport }}</span>
        </div>

        <div>
          <span class="ml2 b"
            >{{
              convertTime(flightStatus?.scheduledArrival) | date: 'shortTime'
            }}
          </span>
          <span class="b">&nbsp;{{ inboundFlightCopy?.arrival }} </span>
        </div>
      </div>
    </div>
    <!-- END DESKTOP -->

    <!-- DIALOG -->
    <div *ngIf="useDialogDisplay" class="mt3 flex">
      <span *ngIf="!isLoading && errorMessage">
        {{ errorMessage }}
      </span>

      <div *ngIf="!errorMessage" class="w-100 flex">
        <div class="w-50 flex flex-column body">
          <div class="b">{{ inboundFlightCopy?.arrives }}</div>

          <div *ngIf="flightStatus" class="mt2">
            {{
              convertTime(flightStatus?.scheduledArrival) | date: 'shortTime'
            }}
          </div>

          <dot-text-block
            *ngIf="isLoading"
            class="mt2"
            bgColor="medium-grey"
            [height]="24"
            [width]="50"
          />
        </div>

        <div class="w-50 flex flex-column">
          <div class="b">{{ inboundFlightCopy?.status }}</div>

          <div *ngIf="flightStatus" class="mt1 dialog-inbound-plane-neg-ml">
            <jb-flight-tracker-results-status-column
              [flightTrackerLeg]="{ flightStatus: flightStatus?.flightStatus }"
              [useStatusColumnCSS]="false"
            />
          </div>

          <dot-text-block
            *ngIf="isLoading"
            class="mt2"
            bgColor="medium-grey"
            [height]="24"
            [width]="50"
          />
        </div>
      </div>
    </div>
    <!-- END DIALOG -->
  </jb-expandable-section>
</div>
